// 跨组 sub group 顾客端每店单号:订单级自愈式门控 + 每店成员号读取。
//
// 背景:type=1 跨组组的成员单各自用本店日序号,父单用 sub-group 独立日序号,
// 两者格式都是 {Ymd}_{4位}。顾客取餐时要对每家店出示该店自己的成员号。
// type=0 普通组由后端强制父单与所有成员单同号,门控恒不触发,展示零变化。
//
// 数据来源:get-order 响应顶层 orderNo = 父号;orderList 以 venueId 为 key,
// 值是数组,每项有 orderNo(成员号)等字段(沿用页内 [0] 约定)。
//
// 门控与展示同源:门控只评估每店“实际展示的”成员号,也就是 storeOrderNo() 返回的
// 那一条([0] 条目)。这样“提示行是否亮”与“页面上是否真有一行号码 ≠ 父号”构造上自洽,
// 不会出现提示行亮了、每店展示的号却都等于父号的怪态。

/**
 * 订单级门控:任一店“展示的”成员号([0] 条目)与父 orderNo 字符串不同 → 整单按跨组样式渲染。
 * 语义:门控开 ⇔ 页面上至少有一行展示的号与父号不同(与展示层 storeOrderNo 同源,构造上自洽)。
 * order / order.orderNo / order.orderList 任一缺失 → false(与现状零差异)。
 * @param {Object} order get-order 响应
 * @returns {Boolean}
 */
export function hasStoreOrderNumbers(order) {
  if (!order || !order.orderNo || !order.orderList) {
    return false
  }
  const parentNo = String(order.orderNo)
  const venueIds = Object.keys(order.orderList)
  for (const venueId of venueIds) {
    const displayed = storeOrderNo(order, venueId)
    if (displayed !== '' && displayed !== parentNo) {
      return true
    }
  }
  return false
}

/**
 * 取某店的成员单号(数组第一条,沿用 checkPosStatus/getOrderCollectionInfo 的 [0] 约定)。
 * 任何缺失 → ''。orderNo 可能是 number,归一为字符串返回。
 * @param {Object} order get-order 响应
 * @param {String} venueId
 * @returns {String}
 */
export function storeOrderNo(order, venueId) {
  const entries = order && order.orderList && order.orderList[venueId]
  if (!Array.isArray(entries) || !entries[0] || entries[0].orderNo == null) {
    return ''
  }
  return String(entries[0].orderNo)
}

/**
 * 取 '_' 分割后的末段(与 Num/index.vue 的 filterOrderNo 同义)。
 * 空入参 → ''。orderNo 可能是 number,归一为字符串处理。
 * @param {String|Number} orderNo
 * @returns {String}
 */
export function shortOrderNo(orderNo) {
  if (orderNo == null || orderNo === '') {
    return ''
  }
  const list = String(orderNo).split('_')
  return list[list.length - 1]
}
